import React from 'react';
import './Button.css';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  disabled = false, 
  loading = false, 
  onClick, 
  type = 'button',
  className = '',
  icon,
  iconPosition = 'left',
  as: Component = 'button',
  ...props 
}) => {
  const buttonClass = `
    btn 
    btn--${variant} 
    btn--${size} 
    ${disabled ? 'btn--disabled' : ''} 
    ${loading ? 'btn--loading' : ''} 
    ${className}
  `.trim().replace(/\s+/g, ' ');

  // Filter out custom props from DOM props
  const { icon: _, iconPosition: __, ...domProps } = props;

  const content = (
    <>
      {icon && iconPosition === 'left' && <span className="btn__icon">{React.isValidElement(icon) ? icon : React.createElement(icon)}</span>}
      {loading ? (
        <span className="btn__spinner">Loading...</span>
      ) : (
        children
      )}
      {icon && iconPosition === 'right' && <span className="btn__icon">{React.isValidElement(icon) ? icon : React.createElement(icon)}</span>}
    </>
  );

  return (
    <Component
      type={Component === 'button' ? type : undefined}
      className={buttonClass}
      disabled={disabled || loading}
      onClick={onClick}
      {...domProps}
    >
      {content}
    </Component>
  );
};

export default Button;